export Project = '''
	id
	projectID
	name
	slug
	city
	country
'''
